// ============================================================
// ForgotPasswordPage.js — Page de réinitialisation de mot de passe
// Envoie un email de reset Auth0 si l'adresse est connue.
// Props :
//   onBack()  — retour à la page de connexion
// ============================================================

import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { API_URL } from './api';

const AppBar = () => (
    <div style={{ backgroundColor: '#1a5c38', padding: '12px 24px', display: 'flex', alignItems: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
        <span style={{ color: 'white', fontWeight: 700, fontSize: '1.25rem', letterSpacing: '0.05em' }}>AVALIST</span>
    </div>
);

const ForgotPasswordPage = ({ onBack }) => {
    const [email,   setEmail]   = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error,   setError]   = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch(API_URL + '/forgot-password', {
                method  : 'POST',
                headers : { 'Content-Type': 'application/json' },
                body    : JSON.stringify({ email }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Erreur serveur');
            setSuccess(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f0f4f0', display: 'flex', flexDirection: 'column', fontFamily: 'Inter, sans-serif' }}>
            <AppBar />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '32px 16px' }}>
                <div style={{
                    backgroundColor : 'white',
                    borderRadius    : '12px',
                    boxShadow       : '0 4px 24px rgba(0,0,0,0.10)',
                    padding         : '40px 36px',
                    width           : '100%',
                    maxWidth        : '400px',
                }}>
                    <h2 style={{ color: '#1a5c38', fontWeight: 700, marginBottom: '6px', fontSize: '1.5rem' }}>
                        Mot de passe oublié
                    </h2>
                    <p style={{ color: '#666', marginBottom: '28px', fontSize: '0.92rem' }}>
                        Entrez votre adresse e-mail. Si un compte y est associé, vous recevrez un lien de réinitialisation.
                    </p>

                    {success ? (
                        <Alert variant="success" style={{ borderRadius: '8px', fontSize: '0.9rem' }}>
                            Si un compte existe avec cet e-mail, un lien de réinitialisation vous a été envoyé. Vérifiez votre boîte de réception (et vos spams).
                        </Alert>
                    ) : (
                        <>
                            {error && (
                                <Alert variant="danger" style={{ borderRadius: '8px', fontSize: '0.9rem' }}>
                                    {error}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group style={{ marginBottom: '24px' }}>
                                    <Form.Label style={{ fontWeight: 500, color: '#333', fontSize: '0.9rem' }}>
                                        Adresse e-mail
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="prenom.nom@exemple.fr"
                                        required
                                        autoFocus
                                        style={{ borderRadius: '8px', border: '1px solid #d0d0d0', padding: '10px 14px', fontSize: '0.95rem' }}
                                    />
                                </Form.Group>

                                <Button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        width           : '100%',
                                        backgroundColor : '#2d8a4e',
                                        borderColor     : '#2d8a4e',
                                        color           : 'white',
                                        padding         : '11px',
                                        borderRadius    : '8px',
                                        fontWeight      : 600,
                                        fontSize        : '1rem',
                                    }}
                                >
                                    {loading
                                        ? <><Spinner animation="border" size="sm" style={{ marginRight: '8px' }} />Envoi en cours…</>
                                        : 'Envoyer le lien de réinitialisation'
                                    }
                                </Button>
                            </Form>
                        </>
                    )}

                    <div style={{ textAlign: 'center', marginTop: '24px' }}>
                        <button
                            onClick={onBack}
                            style={{ background: 'none', border: 'none', color: '#2d8a4e', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500, padding: 0 }}
                        >
                            ← Retour à la connexion
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
